import { request } from "@/utils/request";
import { IP } from "@/services/config.js";

/* 创建会话 */
export function createConversation(data) {
  return request({
    url: `/mobile/conversation/create`,
    method: "POST",
    data,
  });
}

/**
 * 流式创建会话（SSE）
 * @param {object} data - 请求参数（会自动附加 stream: true）
 * @param {function} onChunk - 每收到一段文字时的回调 (delta: string) => void
 * @param {function} onDone  - 流结束回调 () => void
 * @param {function} onError - 错误回调 (err: Error) => void
 * @returns {function} abort - 调用可中止请求
 */
export function createConversationStream(data, onChunk, onDone, onError) {
  const controller = new AbortController();
  const url = IP + "/mobile/conversation/create";

  fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...data, stream: true }),
    signal: controller.signal
  })
    .then(response => {
      if (!response.ok || !response.body) {
        onError && onError(new Error(`请求失败: ${response.status}`));
        return;
      }
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";

      function read() {
        reader
          .read()
          .then(({ done, value }) => {
            if (done) {
              onDone && onDone();
              return;
            }
            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split("\n");
            buffer = lines.pop(); // 保留不完整的行
            for (const line of lines) {
              if (!line.startsWith("data: ")) continue;
              const raw = line.slice(6).trim();
              if (raw === "[DONE]") {
                onDone && onDone();
                return;
              }
              try {
                const parsed = JSON.parse(raw);
                if (parsed.content) {
                  onChunk && onChunk(parsed.content);
                }
                if (parsed.error) {
                  onError && onError(new Error(parsed.error));
                }
              } catch (e) {
                // 忽略 JSON 解析错误
              }
            }
            read();
          })
          .catch(err => {
            if (err.name !== "AbortError") {
              onError && onError(err);
            }
          });
      }
      read();
    })
    .catch(err => {
      if (err.name !== "AbortError") {
        onError && onError(err);
      }
    });

  return () => controller.abort();
}


/**
 * 查询对话记录
 * @param {*} data 
 * @returns 
 */
export function selectConversationList(data) {
  return request({
    url: `/mobile/conversation/select`,
    method: "POST",
    data,
  });
}




/**
 * 上传录音文件
 * @param {File} file - 录音 Blob/File
 * @returns {Promise<{code:number, data:string}>} 返回文件访问 URL
 */
export function writeFiles(file) {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("formData", file);
    const xhr = new XMLHttpRequest();
    xhr.open("POST", IP + "/public/writeFiles/create", true);
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(JSON.parse(xhr.response));
      } else {
        reject(xhr);
        console.error("上传录音失败", xhr.status);
      }
    };
    xhr.onerror = () => reject(xhr);
    xhr.send(formData);
  });
}

/**
 * 语音转文字（ASR）
 * @param {File} audioFile - 音频文件 Blob/File
 * @param {string} language - 语言（可选，默认 auto）
 * @returns {Promise<{code:number, data:{text:string}}>}
 */
export function transcribeAudio(audioFile, language = "auto") {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("audio", audioFile);
    formData.append("language", language);
    // formData.append("save_file", true); //是否保存识别的音频

    const xhr = new XMLHttpRequest();
    xhr.open("POST", IP + "/public/asr/transcribe", true);
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(JSON.parse(xhr.response));
      } else {
        reject(xhr);
        console.error("语音识别失败", xhr.status);
      }
    };
    xhr.onerror = () => reject(xhr);
    xhr.send(formData);
  });
}
